(() => {
  if (window.echoLeadTrackingLoaded || window.Shopify?.designMode) return;
  window.echoLeadTrackingLoaded = true;
  const script = document.querySelector('script[data-echo-lead-tracking]');
  const measurementId = script?.dataset.measurementId;
  const debug = script?.dataset.preview === 'true';
  if (!measurementId) return;
  const pendingKey = 'echo_project_inquiry_pending';
  let privacyReady = false;
  const scheduled = new Set();
  function allowed() {
    return privacyReady && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
  }
  function tag() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
  }
  function send(name, method) {
    if (!allowed()) return false;
    tag('event', name, {
      send_to: measurementId, lead_source: method,
      page_location: location.origin + location.pathname,
      page_title: document.title,
      ...(debug ? {debug_mode: true, traffic_type: 'theme_preview'} : {})
    });
    // Publish successful outcomes only; Shopify's pixel privacy settings gate Meta delivery.
    const metaEvent = {
      generate_lead: 'echo:project_inquiry_completed',
      appointment_booked: 'echo:consultation_booked'
    }[name];
    if (!debug && metaEvent && window.Shopify?.analytics?.publish) {
      try {
        Promise.resolve(window.Shopify.analytics.publish(metaEvent, {lead_source: method})).catch(() => {});
      } catch (_) {}
    }
    if (debug) console.info('[Echo tracking] ' + name + ' queued');
    return true;
  }
  function checkSuccess() {
    if (!allowed() || !document.querySelector('[data-echo-inquiry-success]')) return;
    try {
      const stamp = Number(sessionStorage.getItem(pendingKey));
      if (!stamp || Date.now() - stamp > 30 * 60 * 1000) return;
      sessionStorage.removeItem(pendingKey);
      send('generate_lead', 'project_inquiry');
    } catch (_) {}
  }
  document.addEventListener('submit', (event) => {
    if (event.target?.id !== 'ContactForm' || !event.target.querySelector('[name="contact[body]"]')) return;
    if (!allowed()) return;
    try { sessionStorage.setItem(pendingKey, String(Date.now())); } catch (_) {}
  }, true);
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    const href = link.getAttribute('href');
    if (href.startsWith('tel:')) send('phone_click', 'website_phone');
    else {
      try {
        const url = new URL(link.href);
        if (url.pathname === '/pages/book-a-consultation' || url.hostname === 'calendly.com') {
          send('consultation_click', 'booking_link');
        }
      } catch (_) {}
    }
  });
  window.addEventListener('message', (event) => {
    if (event.origin !== 'https://calendly.com' || event.data?.event !== 'calendly.event_scheduled') return;
    const frames = [...document.querySelectorAll('iframe')];
    if (!frames.some(frame => frame.contentWindow === event.source && frame.src.startsWith('https://calendly.com/'))) return;
    const id = event.data?.payload?.event?.uri;
    const key = typeof id === 'string' ? id : 'current_booking';
    if (scheduled.has(key) || !allowed()) return;
    scheduled.add(key);
    send('appointment_booked', 'calendly_embed');
  });
  function privacyLoaded(error) {
    if (error) return;
    privacyReady = Boolean(window.Shopify?.customerPrivacy);
    checkSuccess();
  }
  document.addEventListener('visitorConsentCollected', () => {
    privacyReady = Boolean(window.Shopify?.customerPrivacy);
    checkSuccess();
  });
  if (window.Shopify?.customerPrivacy) privacyLoaded();
  else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], privacyLoaded);
  }
})();
